export default "__VITE_ASSET__EDdiv7jf__"